import { Box } from '@approvalmax/ui/src/components';
import styled from 'styled-components';

export const SelectWrapper = styled(Box)`
    position: relative;
`;

export const Balance = styled.div`
    position: absolute;
    top: calc(50% + 8px);
    right: calc(12px + 16px + 8px);
    transform: translateY(-50%);
`;
